














import { defineComponent, type PropType } from "vue-demi";
import seedrandom from "seedrandom";

export default defineComponent({
  name: "GGColorAvatar",
  props: {
    name: {
      type: String as PropType<string>,
      default: null,
    },
    img: {
      type: String as PropType<string>,
      default: null,
    },
    /**
     * Размер аватарки
     * Поддерживаются следующие значения: 30, 40, 60, 100
     */
    size: {
      type: String,
      default: "60",
      validator(el) {
        return ["30", "40", "60", "100"].some((item) => item === el);
      },
    },
    /**
     * Размер аватарки в мобильной версии
     * Поддерживаются следующие значения: 25, 30, 40, 60, 70, 100,
     */
    mobileSize: {
      type: String,
      default: "60",
      validator(el) {
        return ["25", "30", "40", "60", "70", "100"].some(
          (item) => item === el
        );
      },
    },
  },
  computed: {
    firstSign() {
      return this.name?.[0];
    },
    color() {
      const seed = seedrandom(this.firstSign)();
      return `hsl(${360 * seed}, 56%, 60%)`;
    },
  },
});
